import React, { ReactNode, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { ChevronUpIcon } from 'assets/icons';
import { useScreenSizeDetection } from 'common/hooks';
import { Button } from 'components/common';
import { Flex } from 'components/styled/Flex';
import { usePropertyState } from 'modules/_common/hooks/usePropertyState';
import { TPrevNextTabs } from 'modules/accommodations/features/rentals/CreateRental/_common/models';
import { useTheme } from 'styled-components';

export const PrevNextTabs = ({
  generatedTabs,
  setActiveTab,
  margin,
  prevBtnLabel,
  nextBtnLabel,
  disablePrevBtn,
  disableNextBtn,
  navigatePrevPath,
  navigateNextPath,
  nextHandlerHelper,
  isLoading,
  skipFirstClick,
  isSticky,
  nextBtnPrefix,
}: {
  generatedTabs?: TPrevNextTabs[];
  setActiveTab?: (activeTab: string) => void;
  margin?: string;
  prevBtnLabel?: string;
  nextBtnLabel?: string;
  disablePrevBtn?: boolean;
  disableNextBtn?: boolean;
  navigatePrevPath?: string;
  navigateNextPath?: string;
  nextHandlerHelper?: () => void;
  isLoading?: boolean;
  skipFirstClick?: boolean;
  isSticky?: boolean;
  nextBtnPrefix?: ReactNode;
}) => {
  const {
    state: { counter },
    setCounter,
  } = usePropertyState();

  const { colors } = useTheme();

  const { isMobile } = useScreenSizeDetection();

  const navigate = useNavigate();

  const tabs = generatedTabs
    ? generatedTabs
    : // default "tab" if generatedTabs is undefined
      [
        {
          label: '',
          path: '',
          component: <></>,
        },
      ];

  useEffect(() => {
    if (tabs) {
      if (tabs[counter]) {
        const { path } = tabs[counter];
        setActiveTab && setActiveTab(path);
      } else {
        if (navigateNextPath && counter > -1) {
          navigate(navigateNextPath);
          setCounter(0);
        } else if (navigatePrevPath) {
          navigate(navigatePrevPath);
          setCounter(0);
        }
      }
    }
  }, [counter]);

  const nextHandler = async () => {
    nextHandlerHelper && (await nextHandlerHelper());

    if (tabs && counter < tabs.length) {
      if (skipFirstClick) return;

      setCounter(counter + 1);
    } else {
      navigate(navigateNextPath as string);
    }
  };

  const previousHandler = () => {
    if (tabs) {
      if (counter >= 0) {
        setCounter(counter - 1);
      }
    } else {
      navigate(navigatePrevPath as string);
    }
  };

  const lastTab = counter === (tabs && tabs?.length - 1);

  return (
    <Flex
      flexDirection="column"
      gap="0.5rem"
      padding="1rem 0 2rem"
      isSticky={isSticky}
      backgroundColor={colors.black_5}
    >
      {isMobile && nextBtnPrefix && <Flex justifyContent="center">{nextBtnPrefix}</Flex>}
      <Flex justifyContent="space-between">
        <Button
          label={prevBtnLabel ? prevBtnLabel : 'Back_'}
          onClick={previousHandler}
          leftIcon={<ChevronUpIcon rotate={-90} />}
          disabled={disablePrevBtn}
        />
        <Flex gap="1rem" alignItems="center">
          {!isMobile && nextBtnPrefix}
          <Button
            label={nextBtnLabel && lastTab ? nextBtnLabel : 'Forward'}
            onClick={nextHandler}
            isFetching={isLoading}
            color="blue"
            rightIcon={<ChevronUpIcon rotate={90} stroke={colors.white} />}
            disabled={disableNextBtn}
          />
        </Flex>
      </Flex>
    </Flex>
  );
};
